<template>
    <v-app>
        <Toolbar title="Transaction Detail"/>
        <v-content>
            <v-layout row>
                <v-flex xs12 sm12 offset-sm0>
                    <v-card>
                        <v-card-title primary-title>
                            <v-btn @click="$router.push({path: '/device/' + groupId + '/' + deviceId})">
                                <v-icon dark>arrow_back</v-icon>
                            </v-btn>
                            <v-spacer></v-spacer>
                            <div>
                                <div class="headline">{{ deviceId }}</div>
                                <span class="grey--text">Group: {{ groupName }}</span>
                            </div>
                        </v-card-title>
                    </v-card>
                </v-flex>


            </v-layout>
            <v-toolbar color="#E0E0E0" slot="header">
                <v-toolbar-title>Transactions</v-toolbar-title>
            </v-toolbar>

            <v-flex xs12 sm12 md10 offset-sm0 offset-md1>
            <v-card>
                <v-card-title primary-title>
                    <h3 class="headline mb-0"> Transaction Record</h3>
                    <v-spacer></v-spacer>
                    <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Search"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                        :headers="statHeaders"
                        :items="statistics"
                        :search="search"
                        :rows-per-page-items = "rowsPerPage"
                >
                    <template slot="items" slot-scope="props">
                        <td class="subheading">{{ props.item.statKey }}</td>
                        <td class="subheading">{{ props.item.statValue }}</td>
                    </template>
                    <v-alert slot="no-results" :value="true" color="error" icon="warning">
                        Your search for "{{ search }}" found no results.
                    </v-alert>
                </v-data-table>
            </v-card>
            </v-flex>
        </v-content>

    </v-app>

</template>

<script>
    import Toolbar from '../components/Toolbar'

    const fb = require('../firebase')

    export default {
        name: "Statistics",
        components: {Toolbar},
        data() {
            return {
                search: '',
                rowsPerPage: [100, 100, {'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1}],
                statistics: [],
                statHeaders: [
                    {text: 'Key', align: 'left', sortable: true, value: 'statKey'},
                    {text: 'Value', align: 'left', sortable: true, value: 'statValue'}
                ],
                txn: {}
            }
        },
        mounted() {
            if (this.deviceId === undefined || this.deviceId === 'undefined') {
                this.$router.push({path: '/groups'})
            }
            this.fetchLastState()
        },
        computed: {
            groupId: function () {
                return this.$route.params['group_id']
            },
            groupName: function () {
                let group = this.$store.state.groups[this.groupId]

                if (group !== undefined) {
                    return group.name
                }
                return ''
            },
            deviceId: function () {
                return this.$route.params['device_id']
            }
        },
        methods: {
            fetchLastState: function () {
                fb.transactionsCollection
                    .where('uuid', '==', this.$route.params.transaction_uuid)
                    .orderBy('timestamp', 'desc')
                    .limit(1)
                    .get()
                    .then((statuses) => {
                        if (!statuses.empty) {
                            statuses.forEach((status) => {
                                let doc = status.data()
                                this.txn = doc
                                for (let key in doc) {
                                    if (doc.hasOwnProperty(key)) {
                                        this.statistics.push({statKey: key, statValue: doc[key]})
                                    }
                                }
                            })
                        }
                    })
            }
        }
    }
</script>

<style scoped>

</style>
